import React, { useMemo } from 'react'
import { isArray, isEmpty } from 'lodash'

import { useRightSidebar } from 'global/hooks/useRightSidebar'
import { useUserWorkshop } from 'global/hooks/useUserWorkshop'

import FormCheck from 'components/Form/FormCheck'

import { useSession } from 'pages/Member/CoachingSessions/hooks'

const RightSidebar = () => {
  const { sideBarData } = useRightSidebar()
  const { data: sessionsData, editSession } = useSession()
  const { editUserWorkshop } = useUserWorkshop()

  const handleEditCheck = ({ id, type, index }) => {
    const newSteps = sideBarData
      .find(x => x.type === type)
      .steps.map((step, stepIndex) => ({
        ...step,
        status: stepIndex === index ? !step.status : step.status
      }))

    if (type === 'coachingSession') {
      return editSession({
        id,
        payload: {
          steps: newSteps
        }
      })
    }

    return editUserWorkshop({
      workshopId: id,
      payload: {
        actionSteps: newSteps
      }
    })
  }

  const visibleSections = useMemo(() => {
    if (!Array.isArray(sideBarData)) return []

    const hasNoSessions =
      Array.isArray(sessionsData) && sessionsData.length === 0

    return sideBarData.filter(section => {
      if (!section) return false
      const { type, steps } = section
      const safeSteps = Array.isArray(steps) ? steps : []

      if (type === 'workshop') {
        return safeSteps.length > 0
      }

      if (type === 'coachingSession') {
        if (hasNoSessions) return false
        return safeSteps.length > 0
      }

      // Default: show other sidebar blocks
      return true
    })
  }, [sideBarData, sessionsData])

  // If there's nothing to show, hide the entire Action Steps panel.
  if (visibleSections.length === 0) {
    return null
  }

  return (
    <div>
      {isArray(sideBarData) && (
        <div>
          <div className="mb-5" style={{ fontSize: 18 }}>
            Action Steps
          </div>
          {sideBarData?.map(
            ({ steps, title, id, type }, parentIndex) => {
              const classes = ['pb-10 mb-20']
              if (sideBarData.length - 1 !== parentIndex) {
                classes.push('border-bottom')
              }

              if (type === 'workshop' && steps.length === 0) {
                return null
              }

              // Hide coaching-session action steps panel if there are no sessions
              // OR if there are no action steps on any sessions (empty steps array).
              if (
                type === 'coachingSession' &&
                ((Array.isArray(sessionsData) &&
                  sessionsData.length === 0) ||
                  steps.length === 0)
              ) {
                return null
              }

              return (
                <div
                  key={parentIndex}
                  className={classes.join(' ')}
                >
                  <p className="font-weight-bold text-primary mb-15">
                    {title}
                  </p>
                  {steps.length ? (
                    steps.map(
                      ({ description, status }, index) => (
                        <FormCheck
                          onChange={() =>
                            handleEditCheck({ id, type, index })
                          }
                          controlId={`actionStep[${parentIndex}][${index}]`}
                          key={`actionStep[${parentIndex}][${index}]`}
                          label={description}
                          defaultChecked={status}
                        />
                      )
                    )
                  ) : (
                    <p className="text-center">No data.</p>
                  )}
                </div>
              )
            }
          )}
        </div>
      )}
    </div>
  )
}

export default RightSidebar
